module.exports = __webpack_public_path__ + "img/filter.c5a19813.svg";